/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/buttons');
require('./main/back-to-top-button');
require('./main/sticky-navbar');
require('./main/join-us-button');
require('./main/accordions');
require('./main/magazines-carousel');
require('./main/listings');
require('./main/search-results');
require('./main/video-thumbnail-embed');
require('./main/video-thumbnail-play-on-hover');
require('./main/tabs');
